import React, {FC, Fragment, useState} from 'react';
import {Link} from 'react-router-dom';

import {BetData, GenericProps} from 'utils/types';
import useBreakpointXL from 'hooks/useBreakpointXL';

import './styles.scss';
import arrow from 'assets/svg/bet_arrow.svg';

interface Props extends GenericProps {
    className?: string;
    collapsible?: boolean;
    betData: BetData;
}

const WidgetBet: FC<Props> = ({className, collapsible, betData: {provider, odds, externalLink}}: Props) => {
    const [collapsed, setCollapsed] = useState(collapsible);
    const isBreakpointXL = useBreakpointXL();
    return (
        <>
            {odds && odds.length > 1 && (
                <section className={`WidgetBet ${className ?? ''}`}>
                    <>{!collapsible ? <h2 className="WidgetBet__header">BET</h2> : ""}
                    {provider && provider.imageUrl && (
                        <div className="WidgetBet__provider">

                                            <span className="WidgetBet__providerLabel">POWERED BY</span>
                        {provider.clickUrl ? (
                            <a
                                className="WidgetBet__providerLogo"
                                href={provider.clickUrl}
                                target="_blank"
                                rel="external noopener noreferrer"
                            >
                                <img src={provider.imageUrl} alt={provider.name}/>
                            </a>
                        ) : (
                            <div className="WidgetBet__providerLogo">
                                <img src={provider.imageUrl} alt={provider.name}/>
                            </div>
                        )}
                    </div>)}

                        <div className={`WidgetBet__oddsWrapper ${collapsed ? 'WidgetBet__oddsWrapper--collapsed' : ''}`}>
                            {odds.map(group => (
                                <Fragment key={group.id}>
                                    <h6 className="WidgetBet__oddsHeader">{group.title}</h6>
                                    {group.values.map((value, i) => {
                                        let tileType;
                                        if (['MRES', 'BTSC', 'HCTG'].includes(group.type)) {
                                            if (i === 0) tileType = 'home';
                                            else if (i === group.values.length - 1) tileType = 'away';
                                            else tileType = 'tie';
                                        }
                                        return (
                                            <a
                                                href={externalLink}
                                                target="_blank"
                                                rel="external nofollow noopener noreferrer"
                                                className={`WidgetBet__oddsTile ${
                                                    tileType ? `WidgetBet__oddsTile--${tileType}` : ''
                                                }`}
                                                key={`${value.id}`}
                                            >
                                                {'label' in value && (
                                                    <span className="WidgetBet__oddsLabel">{value.label}</span>
                                                )}
                                                <span className="WidgetBet__oddsValue">{value.value.toFixed(Math.max(2, (value.value.toString().split('.')[1] || []).length))}</span>
                                            </a>
                                        );
                                    })}
                                </Fragment>
                            ))}
                        </div>
                    </>
                </section>
            )}
            {odds && odds.length > 1 && provider && provider.imageUrl && (
                <section className={`WidgetBet ${className ?? ''}`}>
                    <div className="WidgetBet__provider">
                        {/* <span className="WidgetBet__providerLabel">POWERED BY</span>
                        {provider.clickUrl ? (
                            <a
                                className="WidgetBet__providerLogo"
                                href={provider.clickUrl}
                                target="_blank"
                                rel="external noopener noreferrer"
                            >
                                <img src={provider.imageUrl} alt={provider.name}/>
                            </a>
                        ) : (
                            <div className="WidgetBet__providerLogo">
                                <img src={provider.imageUrl} alt={provider.name}/>
                            </div>
                        )} */}
                        <div className="WidgetBet__provider">
                            {collapsible && (
                                <div className="WidgetBet__expander">
                                    <button
                                        className="WidgetBet__expanderButton"
                                        type="button"
                                        onClick={() => setCollapsed(!collapsed)}
                                    >
                                        <img
                                            className={`WidgetBet__expanderArrow ${
                                                collapsed ? 'WidgetBet__expanderArrow--collapsed' : ''
                                            }`}
                                            src={arrow}
                                            alt="expand"
                                        />
                                    </button>
                                </div>
                            )}
                            <span className="WidgetBet__providerDisclaimer">21+ | ΡΥΘΜΙΣΤΗΣ ΕΕΕΠ | ΓΡΑΜΜΗ ΒΟΗΘΕΙΑΣ ΚΕΘΕΑ: 210 9237777 | ΠΑΙΞΕ ΥΠΕΥΘΥΝΑ. | ΟΙ ΑΠΟΔΟΣΕΙΣ ΕΝΔΕΧΕΤΑΙ ΝΑ ΥΠΟΚΕΙΝΤΑΙ ΣΕ ΑΛΛΑΓΕΣ.</span>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};

export default WidgetBet;
